import { render, staticRenderFns } from "./RecurringShipments.vue?vue&type=template&id=d0430370&"
import script from "./RecurringShipments.vue?vue&type=script&lang=js&"
export * from "./RecurringShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports